import { createFileRoute } from '@tanstack/react-router';
import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ButtonLink from '@/components/ButtonLink.tsx';

export const Route = createFileRoute('/_manager/_setup/subscription-past-due')({
  component: SubscriptionPastDue,
});

function SubscriptionPastDue() {
  const { t } = useTranslation(['manager']);

  return (
    <Container
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: 6,
      }}
      maxWidth="md">
      <Typography variant="h2" align="center">
        {t('manager:subscriptionPastDue.title')}
      </Typography>
      <Typography variant="h5" align="center">
        {t('manager:subscriptionPastDue.message')}
      </Typography>
      <ButtonLink to="/customer-portal" variant="contained" size="large">
        {t('manager:manageStripeAccountButton')}
      </ButtonLink>
    </Container>
  );
}
